import { computed } from 'vue'

import type {
  AddToCalendarModalType,
  AdminGroupStructureModalType,
  AdminManualUserImportModalType,
  AdminReminderStructureModalType,
  AdminUsersImportModalType,
  ConfirmActionModalType,
  ContactWarningModalType,
  EditProfileModalType,
  EditSessionModalType,
  GroupSettingsModalType,
  ObjectiveDescriptionModalType,
  LinkSessionToObjectiveModalType,
  MeetingModalType,
  MenteeMatchingModalType,
  MentorMatchingModalType,
  MfaDisableModalType,
  MfaLoginModalType,
  MfaSetupModalType,
  ImpersonationReasonModalType,
  ModalsStoreValuesType,
  NameMissingModalType,
  NewMatchingModalType,
  NewSessionModalType,
  NoMentorFoundModalType,
  NoProgramModalType,
  PhoneModalType,
  ProfileDescriptionModalType,
  ProfilePictureModalType,
  ProgramCriteriasModalType,
  ProgramObjectiveModalType,
  ReviewSessionModalType,
  SessionDetailsModalType,
  TermsModalType,
  UserProfileModalType,
} from '@/features/ui/store/modal/modal.store'

export function selectGetAllModal(state: ModalsStoreValuesType) {
  return computed(() => state.modals as ModalsStoreValuesType['modals'])
}

export function selectGetShouldHideMatchingModals(state: ModalsStoreValuesType) {
  return computed(() => state.shouldHideMatchingModals)
}

export function selectGetPhoneModal(state: ModalsStoreValuesType) {
  return computed(() => state.modals['phone'] as PhoneModalType)
}

export function selectGetMentorMatchingModal(state: ModalsStoreValuesType) {
  return computed(() => state.modals['mentor-matching'] as MentorMatchingModalType)
}

export function selectGetMenteeMatchingModal(state: ModalsStoreValuesType) {
  return computed(() => state.modals['mentee-matching'] as MenteeMatchingModalType)
}

export function selectGetNoProgramModal(state: ModalsStoreValuesType) {
  return computed(() => state.modals['no-program'] as NoProgramModalType)
}

export function selectGetConfirmActionModal(state: ModalsStoreValuesType) {
  return computed(() => state.modals['confirm-action'] as ConfirmActionModalType)
}

export function selectGetNewSessionModal(state: ModalsStoreValuesType) {
  return computed(() => state.modals['new-session'] as NewSessionModalType)
}

export function selectGetMeetingModal(state: ModalsStoreValuesType) {
  return computed(() => state.modals['meeting'] as MeetingModalType)
}

export function selectGetUserProfileModal(state: ModalsStoreValuesType) {
  return computed(() => state.modals['user-profile'] as UserProfileModalType)
}


export function selectGetProfileDescriptionModal(state: ModalsStoreValuesType) {
  return computed(() => state.modals['profile-description'] as ProfileDescriptionModalType)
}

export function selectGetProfilePictureModal(state: ModalsStoreValuesType) {
  return computed(() => state.modals['profile-picture'] as ProfilePictureModalType)
}

export function selectGetEditProfileModal(state: ModalsStoreValuesType) {
  return computed(() => state.modals['edit-profile'] as EditProfileModalType)
}

export function selectGetReviewSessionModal(state: ModalsStoreValuesType) {
  return computed(() => state.modals['review-session'] as ReviewSessionModalType)
}

export function selectGetSessionDetailsModal(state: ModalsStoreValuesType) {
  return computed(() => state.modals['session-details'] as SessionDetailsModalType)
}

export function selectGetAdminUsersImportModal(state: ModalsStoreValuesType) {
  return computed(() => state.modals['admin-users-import'] as AdminUsersImportModalType)
}

export function selectGetAdminManualUserImportModal(state: ModalsStoreValuesType) {
  return computed(() => state.modals['admin-manual-user-import'] as AdminManualUserImportModalType)
}

export function selectGetNewMatchingModal(state: ModalsStoreValuesType) {
  return computed(() => state.modals['new-matching'] as NewMatchingModalType)
}

export function selectGetAddToCalendarModal(state: ModalsStoreValuesType) {
  return computed(() => state.modals['add-to-calendar'] as AddToCalendarModalType)
}

export function selectGetTermsModal(state: ModalsStoreValuesType) {
  return computed(() => state.modals['terms'] as TermsModalType)
}

export function selectGetAdminGroupStructureModal(state: ModalsStoreValuesType) {
  return computed(() => state.modals['admin-group-structure'] as AdminGroupStructureModalType)
}

export function selectGetReminderStructureModal(state: ModalsStoreValuesType) {
  return computed(() => state.modals['admin-reminder-structure'] as AdminReminderStructureModalType)
}

export function selectGetProgramCriteriasModal(state: ModalsStoreValuesType) {
  return computed(() => state.modals['program-criterias'] as ProgramCriteriasModalType)
}

export function selectGetGroupSettingsModal(state: ModalsStoreValuesType) {
  return computed(() => state.modals['group-settings'] as GroupSettingsModalType)
}

export function selectGetObjectiveDescriptionModal(state: ModalsStoreValuesType) {
  return computed(() => state.modals['objective-description'] as ObjectiveDescriptionModalType)
}

export function selectGetEditSessionModal(state: ModalsStoreValuesType) {
  return computed(() => state.modals['edit-session'] as EditSessionModalType)
}

export function selectGetNoMentorFoundModal(state: ModalsStoreValuesType) {
  return computed(() => state.modals['no-mentor-found'] as NoMentorFoundModalType)
}

export function selectGetNameMissingModal(state: ModalsStoreValuesType) {
  return computed(() => state.modals['name-missing'] as NameMissingModalType)
}

export function selectGetContactWarningModal(state: ModalsStoreValuesType) {
  return computed(() => state.modals['contact-warning'] as ContactWarningModalType)
}

export function selectGetMfaSetupModal(state: ModalsStoreValuesType) {
  return computed(() => state.modals['mfa-setup'] as MfaSetupModalType)
}

export function selectGetMfaDisableModal(state: ModalsStoreValuesType) {
  return computed(() => state.modals['mfa-disable'] as MfaDisableModalType)
}

export function selectGetMfaLoginModal(state: ModalsStoreValuesType) {
  return computed(() => state.modals['mfa-login'] as MfaLoginModalType)
}

export function selectGetLinkSessionToObjectiveModal(state: ModalsStoreValuesType) {
  return computed(() => state.modals['link-session-to-objective'] as LinkSessionToObjectiveModalType)
}

export function selectGetProgramObjectiveModal(state: ModalsStoreValuesType) {
  return computed(() => state.modals['program-objective'] as ProgramObjectiveModalType)
}

export function selectGetImpersonationReasonModal(state: ModalsStoreValuesType) {
  return computed(() => state.modals['impersonation-reason'] as ImpersonationReasonModalType)
}
